import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';
import Page from 'pages/page';
import withRouterHooks from 'utils/routerHelper';

class Job extends React.Component {
  _getTabOptions() {
    const { strings } = this.props;
    return [
      { value: '/submissions', text: strings.submissions },
      { value: '/in_progress', text: strings.inProgress },
    ];
  }

  _getTabValue() {
    const tabOptions = this._getTabOptions();
    let tabValue = tabOptions[0].value;
    for (let i = 0; i < tabOptions.length; i += 1) {
      if (this.props.location.pathname === tabOptions[i].value
        || this.props.location.pathname.indexOf(tabOptions[i].value) !== -1) {
        tabValue = tabOptions[i].value;
      }
    }
    return tabValue;
  }

  render() {
    return (
      <Page {...this.props}>
        <div>
          <Components.TabBar
            onChange={Utils.Router.transitionTo}
            options={this._getTabOptions()}
            value={this._getTabValue()}
          />
        </div>
        {this.props.children}
      </Page>
    );
  }
}

Job.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  strings: PropTypes.shape({
    submissions: PropTypes.string,
    inProgress: PropTypes.string,
  }).isRequired,
};

export default withRouterHooks(translate('Job.Tab')(Job));
